<form [formGroup]="quizForm">
   <!-- Lecture Dropdown -->
   <div class="input-select mb-12">
      <label class="text-slate-800 font-semibold text-sm" for="lecture" i18n>Select a Related Lecture (Optional)</label>
      <p class="text-slate-700 text-xs font-normal mb-2" i18n>
         Select the lecture most relevant to your quiz. 
      </p>
      <select formControlName="lecture">
         <option value="" [selected]="true">Select a Related Lecture</option>
         <option *ngFor="let lecture of relatedLectureOption" [value]="lecture.value">{{ lecture.label }}</option>
      </select>
      <div class="flex items-start w-full flex-col mt-2">
         <app-ai-button 
            type="btn-fill" 
            (btnEvent)="createQuizWithAI($event)" 
            [prompt]="true" 
            promptLabel="Number of Answer" i18n-promptLabel
            promptPlaceholder="Example: 2,3,4..." i18n-promptPlaceholder
            label="Generate Set with AI" i18n-label>
         </app-ai-button>
      </div>
   </div>

   <!-- Question Input -->
   <div class="input-group mb-12 gap-0">
      <div class="flex items-center justify-between w-full">
         <span class="p-2.5 bg-slate-100 rounded-tl-xl rounded-tr-xl" i18n>Question</span>
         <app-ai-button type="btn-transparent" (btnEvent)="createQuizQuestionWithAI($event)">
         </app-ai-button>
      </div>
      <div class="p-2.5 bg-slate-100 rounded-b-xl rounded-tr-xl w-full">
         <input class="input-field w-full" type="text" formControlName="question" i18n-placeholder placeholder="Enter your question" />
      </div>
      @if(quizForm.get('question')?.invalid && quizForm.get('question')?.touched){
      <p class="mb-0 text-xs text-red-500 mt-2" i18n>Question is required.</p>
      }
   </div>

   <!-- Answers Section -->
   <div class="answers-section">
      <span class="p-2.5 bg-slate-100 rounded-tl-xl rounded-tr-xl" i18n>Options</span>
      <div class="p-2.5 bg-slate-100 rounded-b-xl rounded-tr-xl w-full" cdkDropList (cdkDropListDropped)="drop($event)">
         <div *ngFor="let answer of answers.controls; let i = index" [attr.id]="'answer-' + i" class="answer-group" [formGroup]="answer"
            [cdkDragDisabled]="!answer.get('isSaved')?.value" cdkDrag>
            <!-- Checkbox/Radio for correct answer -->
            <div [ngClass]="questionType === 'multi_choice' ? 'input-check' : 'input-radio'">
               @if(questionType === 'multi_choice'){
                  <input type="checkbox" formControlName="is_correct" (change)="selectCorrectAnswer(i)" class="checked:!bg-green-500 !border-green-500" />
               }@else{
                  <input type="radio" name="is_correct_group" [checked]="answer.get('is_correct')?.value" (change)="selectCorrectAnswer(i)" class="checked:!bg-green-500 !border-green-500"/>
               }
            </div>

            <div class="answer-group-box" 
               [class.selected-boarder]="answer.get('is_correct')?.value"
               [ngClass]="{'selected': answer.get('isSaved')?.value && answer.get('is_correct')?.value}">
               <!-- Label -->
               <div class="flex justify-between items-center">
                  @if(questionType === 'multi_choice' || questionType === 'single_choice_in_multi'){
                  <div class=" flex items-center gap-3 relative">
                     <span class="text-slate-900 font-semibold text-sm w-8 h-8 bg-slate-100 rounded-md flex items-center justify-center">
                        {{getAlphabetArray(i)}}
                     </span>
                     @if(answer.get('is_correct')?.value){
                     <p class="mb-0 text-sm font-bold text-green-600 absolute left-10 w-24" i18n>Correct Ans.</p>
                     }
                  </div>
                  }
                  @if(questionType === 'single_choice'){
                     @if(i === 0){
                     <div class="flex items-center gap-3" i18n> True </div>
                     }@else{
                     <div class="flex items-center gap-3" i18n> False </div>
                     }
                  }
                  @if(answer.get('isSaved')?.value){
                  <svg-icon cdkDragHandle src="@assets/images/icons/drag.svg" class="question-drag-drop btn-icon"></svg-icon>
                  <!-- Save/Edit Buttons -->
                  <div class="edit-actions !gap-0">
                     <button class="btn btn-sm btn-transparent" type="button" (click)="editAnswer(i)">
                        <svg-icon src="@assets/images/icons/pencil-edit-01.svg" class="btn-icon"></svg-icon>
                     </button>
                     <button class="btn btn-sm btn-transparent" type="button" (click)="removeAnswer(i, answer.get('id')?.value)">
                        <svg-icon src="@assets/images/icons/x-mark.svg" class="btn-icon"></svg-icon>
                     </button>
                  </div>
                  }
                  @if(!answer.get('isSaved')?.value && questionType !== 'single_choice'){
                  <app-ai-button 
                     type="btn-icon" 
                     (btnEvent)="createQuizAnswerWithAI($event, i, answer.get('is_correct')?.value)">
                  </app-ai-button>
                  }
               </div>
               <!-- Answer Input or Preview Mode -->
               @if(questionType === 'multi_choice' || questionType === 'single_choice_in_multi'){
               <div class="input-group">
                  <input class="input-field" *ngIf="!answer.get('isSaved')?.value" type="text" formControlName="answer" i18n-placeholder placeholder="Enter answer" />
                  <p (click)="editAnswer(i)" class="p-3 text-slate-700 mb-0" *ngIf="answer.get('isSaved')?.value">
                     {{ answer.get('answer')?.value }}
                  </p>
                  @if(answers.at(i).get('answer')?.invalid && answers.at(i).get('answer')?.touched){
                  <p class=" mb-0 text-xs text-red-500" i18n>Answer is required.</p>
                  }
               </div>
               }

               <!-- Explanation Input or Preview Mode -->
               @if(!answer.get('isSaved')?.value || answer.get('expected')?.value){
               <div class="input-group">
                  <textarea class="input-field" *ngIf="!answer.get('isSaved')?.value" formControlName="expected"
                  i18n-placeholder placeholder="Explain why this is correct (Optional)"></textarea>
                  <p class="p-3 text-slate-700 mb-0" *ngIf="answer.get('isSaved')?.value">{{ answer.get('expected')?.value }}</p>
               </div>
               }

               <!-- Save/Edit Buttons -->
               @if(!answer.get('isSaved')?.value){
               <div class="actions">
                  <button (click)="removeAnswer(i, answer.get('id')?.value)" *ngIf="answers.controls.length > 2" type="button" class="btn btn-sm" i18n>Delete</button>
                  <button [disabled]="!isAnswerValid(i)" (click)="saveAnswer(i)" type="button" class="btn btn-sm btn-light" i18n>Ok</button>
               </div>
               }
            </div>
         </div>

         @if(questionType === 'multi_choice' || questionType === 'single_choice_in_multi'){
            <button class="btn btn-sm btn-transparent" type="button" (click)="addAnswer()">
               <svg-icon src="@assets/images/icons/plus.svg" class="btn-icon"></svg-icon>
               <span i18n>Add Option</span>
            </button>
         }
      </div>
   </div>
</form>